import Vue from 'vue'
import Router from 'vue-router'
import PosterReg from '@/pages/PosterReg'
import AllPosters from '@/pages/AllPosters'
import SignIn from '@/pages/SignIn'
import SignageReg from '@/pages/SignageReg'
import AllSignages from '@/pages/AllSignages'
import PosterDetail from '@/pages/PosterDetail'
import TempPassword from '@/pages/TempPassword'
import MyPage from '@/pages/MyPage'

import Admin from '@/pages/Admin'
import AllPostersForAdmin from '@/pages/AllPostersForAdmin'
import AllFeeds from '@/pages/AllFeeds'
import AllClubs from '@/pages/AllClubs'
import ClubDetail from '@/pages/ClubDetail'
import PhotoUpload from '@/pages/PhotoUpload'
import TestServer from '@/pages/TestServer'
import AllAdverts from '@/pages/AllAdverts'
import AllEvents from '@/pages/AllEvents'
import AllInvalidUsers from '@/pages/AllInvalidUsers'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'PosterReg',
      component: PosterReg
    },
    {
      path: '/posters',
      name: 'AllPosters',
      component: AllPosters
    },
    {
      path: '/posters/:posterIdx',
      name: 'PosterDetail',
      component: PosterDetail
    },
    {
      path: '/login',
      name: 'SignIn',
      component: SignIn
    },
    {
      path: '/signages',
      name: 'AllSignages',
      component: AllSignages,
      // children: [{
      //   path: 'register',
      //   name: 'SignageReg',
      //   component:  SignageReg
      // }]
    },
    {
      path: '/signages/register',
      name: 'SignageReg',
      component: SignageReg,
    },
    {
      path: '/mypage',
      name: 'MyPage',
      component: MyPage
    },
    {
      path: '/temppassword',
      name: 'TempPassword',
      component: TempPassword
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin
    },
    {
      path: '/admin/posters',
      name: 'AllPostersForAdmin',
      component: AllPostersForAdmin
    },
    {
      path: '/admin/feeds',
      name: 'AllFeeds',
      component: AllFeeds
    },
    {
      path: '/admin/clubs',
      name: 'AllClubs',
      component: AllClubs
    },
    {
      path: '/admin/clubs/:clubIdx',
      name: 'ClubDetail',
      component: ClubDetail
    },
    {
      path: '/admin/util/photos',
      name: 'PhotoUpload',
      component: PhotoUpload
    },
    {
      path: '/admin/deleteMyData',
      name: 'TestServer',
      component: TestServer
    },
    {
      path: '/admin/adverts',
      name: 'AllAdverts',
      component: AllAdverts
    },
    {
      path: '/admin/events',
      name: 'AllEvents',
      component: AllEvents
    },
    {
      path: '/admin/users/invalidUniv',
      name: 'AllInvalidUsers',
      component: AllInvalidUsers
    },
    {
      path: '*',
      name: 'NotFound',
      component: {template: '<div>요청한 페이지를 찾을 수 없습니다</div>'}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js